export default __webpack_public_path__ + "static/media/clipboard.f0cb9cb3.svg";